let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("i0dpz")]).then(() => parcelRequire('amnp6'));